import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import ARTICLES from '../data/articles.json';
import PAGE_SEO from '../data/pageSeo.json';

// Cycled per card so a growing list stays visually varied while all the
// colours stay inside the site's rose/plum palette.
const ACCENTS = [
  { color: '#C8698A', soft: '#fdf1f5' },
  { color: '#6b4c80', soft: '#f4ecfa' },
  { color: '#4CAF50', soft: '#edf7ee' },
  { color: '#a855c8', soft: '#f8effc' },
];

export const Blog = () => {
  const articles = Object.entries(ARTICLES);

  return (
    <>
      <Helmet>
        <title>{PAGE_SEO.blog.title}</title>
        <meta name="description" content={PAGE_SEO.blog.description} />
        <link rel="canonical" href="https://stamsyart.bg/blog" />
      </Helmet>

      <div className="content-wrap">
        <nav className="catalog-breadcrumb">
          <Link to="/">Начало</Link>
          <span>/</span>
          <span>Полезно</span>
        </nav>

        <header className="blog-hero">
          <h1>{PAGE_SEO.blog.h1}</h1>
          <p>{PAGE_SEO.blog.intro}</p>
        </header>

        <div className="article-grid">
          {articles.map(([slug, article], i) => {
            const accent = ACCENTS[i % ACCENTS.length];
            return (
              <Link
                key={slug}
                to={`/blog/${slug}`}
                className="article-card"
                style={{ '--accent': accent.color, '--accent-soft': accent.soft }}
              >
                {article.emoji && <span className="article-emoji">{article.emoji}</span>}
                <div className="article-meta-row">
                  {article.tag && <span className="article-tag">{article.tag}</span>}
                  {article.readingTime && (
                    <span className="article-time">{article.readingTime}</span>
                  )}
                </div>
                <h2>{article.h1}</h2>
                <p>{article.cardText || article.description}</p>
                <span className="article-more">Прочети наръчника →</span>
              </Link>
            );
          })}
        </div>
      </div>
    </>
  );
};
